import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function CategorySection() {
  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-900">
            探索分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1.5">多种题材任你选择，找到你最喜欢的漫画类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 hover:translate-y-[-2px] transition-all duration-300 cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl ${cat.color} text-background-50 mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{cat.count}部作品</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}